// src/stories.js
import {
  List,
  Datagrid,
  TextField,
  DeleteButton,
  Show,
  SimpleShowLayout,
  Button,
  TextInput,
  SimpleForm,
  Create,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  useRecordContext,
  useDataProvider,
  useRefresh,
  useNotify,
  ReferenceField,   // ✅ added for showing emotion details
} from "react-admin";

// ✅ Custom StoryField (always shows something)
const StoryField = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <div style={{ whiteSpace: "pre-wrap", lineHeight: 1.5 }}>
      {record.story || "—"}
    </div>
  );
};

// ✅ Story List
export const StoryList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" />

      {/* Pull Emotion fields */}
      <ReferenceField label="Emotion" source="emotion" reference="emotions">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="EMQ Momentum" source="emotion" reference="emotions">
        <TextField source="EMQmomentum" />
      </ReferenceField>
      <ReferenceField label="EMQ Formation" source="emotion" reference="emotions">
        <TextField source="EMQformation" />
      </ReferenceField>

      <TextField source="event" />
      <TextField source="duck" />
      <TextField source="status" />
      <StoryField />
      <DeleteButton />
    </Datagrid>
  </List>
);

// ✅ Create Story
export const StoryCreate = (props) => (
  <Create {...props}>
    <SimpleForm defaultValues={{ status: "waiting", story: "" }}>
      <ReferenceInput label="Emotion" source="emotion" reference="emotions">
        <AutocompleteInput
          optionText={(record) =>
            record
              ? `${record.name} (${record.EMQmomentum || "-"} | ${
                  record.EMQformation || "-"
                })`
              : ""
          }
        />
      </ReferenceInput>

      <TextInput source="event" />
      <SelectInput
        source="duck"
        choices={[
          { id: "Penny", name: "Penny" },
          { id: "Double O’Quack", name: "Double O’Quack" },
          { id: "Sky Duck", name: "Sky Duck" },
        ]}
      />
      <TextInput source="status" />
      <TextInput source="story" multiline fullWidth />
    </SimpleForm>
  </Create>
);

// ✅ Dummy "Generate Prompt" button
const GeneratePromptButton = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <Button
      label="Generate Prompt"
      onClick={() =>
        alert(
          `Generate Prompt:\nDuck: ${record.duck}\nEmotion: ${record.emotion}\nEvent: ${record.event}\nFormation: ${record.formation}`
        )
      }
    />
  );
};

// ✅ Real "Send to ChatGPT" button
const SendToChatGPTButton = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();

  if (!record) return null;

  const handleClick = async () => {
    try {
      const response = await fetch(
        "https://us-central1-pondlifeapp.cloudfunctions.net/api/generateStory",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            duck: record.duck,
            emotion: record.emotion,
            event: record.event,
            formation: record.formation,
          }),
        }
      );

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();

      await dataProvider.update("stories", {
        id: record.id,
        data: { ...record, story: data.story, status: "completed" },
        previousData: record,
      });

      notify("✅ Story generated and saved", { type: "info" });
      refresh();
    } catch (error) {
      console.error("Error calling generateStory:", error);
      notify("❌ Failed to generate story", { type: "warning" });
    }
  };

  return <Button label="Send to ChatGPT" onClick={handleClick} />;
};

// ✅ Show Story
export const StoryShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      {/* Pull Emotion fields */}
      <ReferenceField label="Emotion" source="emotion" reference="emotions">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="EMQ Momentum" source="emotion" reference="emotions">
        <TextField source="EMQmomentum" />
      </ReferenceField>
      <ReferenceField label="EMQ Formation" source="emotion" reference="emotions">
        <TextField source="EMQformation" />
      </ReferenceField>

      <TextField source="event" />
      <TextField source="duck" />
      <TextField source="status" />
      <StoryField />
      <GeneratePromptButton />
      <SendToChatGPTButton />
    </SimpleShowLayout>
  </Show>
);
